module.exports = "/images/arrow-down.svg?e8b054cd235d1ed9e6517941b17570e2";